import Axios from 'axios'

import { withAuth } from './auth-token-api-utils'

export const getJson = (url: string) => withAuth(() => Axios.get(url).then(resp => resp.data))

export const postJson = (url: string, data: any) => withAuth(() => Axios.post(url, data))

export const deleteJson = (url: string, data: any) => withAuth(() => Axios.delete(url, { data }))
